<template>
  <div v-if="!onChangingState && (canConfirmOrder || canRejectOrder || canCancelOrder)">
    <hr />
    <div class="row mt-4 mb-3 text-center">
      <div class="col-md-4 col-sm-12">
        <base-button v-if="canConfirmOrder" type="success" @click="onConfirmOrder">
          <i class="fas fa-check mr-1"></i><span>Aceptar Pedido</span>
        </base-button>
      </div>
      <div class="col-md-4 col-sm-12">
        <base-button v-if="canRejectOrder" type="danger" @click="onRejectOrder">
          <i class="fas fa-ban mr-1"></i><span>Rechazar Pedido</span>
        </base-button>
      </div>
      <div class="col-md-4 col-sm-12">
        <base-button v-if="canCancelOrder" type="warning" @click="onCancelOrder">
          <i class="fas fa-times mr-1"></i><span>Cancelar Pedido</span>
        </base-button>
      </div>
    </div>
  </div>
</template>

<script>
import OrdersService from '@/services/resources/orders.service';
import OrderEventBus from '@/events/buses/orders.event';
import swal from 'sweetalert2';

export default {
  props: {
    onChangingState: {
      type: Boolean,
      required: true,
    },

    order: {
      type: Object,
      required: true,
    },

    orderId: {
      type: Number,
      required: true,
    },

    isOrderOpen: {
      type: Boolean,
      required: true,
    },

    isOrderPending: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    canConfirmOrder() {
      return this.$can('confirm', 'orders') && this.isOrderPending;
    },

    canRejectOrder() {
      return this.$can('reject', 'orders') && this.isOrderPending;
    },

    canCancelOrder() {
      return (
        this.$can('store', 'orders') &&
        (this.isOrderOpen || this.isOrderPending) &&
        this.$auth.user().data.id === this.order.userId
      );
    },
  },

  created() {
    OrderEventBus.$on('orders-close', this.closeOrder);
  },

  beforeDestroy() {
    OrderEventBus.$off('orders-close', this.closeOrder);
  },

  methods: {
    onConfirmOrder() {
      OrderEventBus.onAccept();
      OrderEventBus.onChangingState(true);
    },

    onRejectOrder() {
      OrderEventBus.onReject();
      OrderEventBus.onChangingState(true);
    },

    onCancelOrder() {
      OrderEventBus.onCancel();
      OrderEventBus.onChangingState(true);
    },

    closeOrder(state, comment) {
      if (state === OrdersService._STATE_ACCEPTED) {
        this.acceptOrder(comment);
      } else if (state === OrdersService._STATE_REJECTED) {
        this.rejectOrder(comment);
      } else if (state === OrdersService._STATE_CANCELED) {
        this.cancelOrder(comment);
      }
    },

    acceptOrder(comment) {
      this.msg({
        title: 'Se aceptará el pedido. Se enviará la confirmación por email al productor junto con el comprobante.',
        type: 'question',
        btnType: 'success',
      }).then((result) => {
        if (result.value) {
          this.$services
            .resource('orders')
            .accept(this.orderId, comment)
            .then((res) => res.data.data)
            .then((order) => this.successResponse(order, 'El Pedido ha sido Aceptado!'));
        }
      });
    },

    rejectOrder(comment) {
      this.msg({
        title: 'Se rechazará el pedido. Se enviará el motivo de rechazo por email al productor.',
      }).then((result) => {
        if (result.value) {
          this.$services
            .resource('orders')
            .reject(this.orderId, comment)
            .then((res) => res.data.data)
            .then((order) => this.successResponse(order, 'El Pedido ha sido Rechazado!'));
        }
      });
    },

    cancelOrder(comment) {
      this.msg({
        title: 'Se cancelará el pedido',
      }).then((result) => {
        if (result.value) {
          this.$services
            .resource('orders')
            .cancel(this.orderId, comment)
            .then((res) => res.data.data)
            .then((order) => this.successResponse(order, 'El Pedido ha sido Cancelado!'));
        }
      });
    },

    successResponse(order, message) {
      OrderEventBus.setNewState(order.state);
      OrderEventBus.onChangingState(false);
      swal('Listo!', message, 'success');
    },

    msg(props) {
      props = {
        ...{
          text: '¿Desea proceder?',
          type: 'warning',
          btnType: 'danger',
        },

        ...props,
      };

      return swal({
        title: props.title,
        text: props.text,
        type: props.type,
        showCancelButton: true,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${props.btnType}`,
        cancelButtonClass: 'btn btn-secondary',
      });
    },
  },
};
</script>
